import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { addOrEditItems } from "../../instantAnswers/orders-addOrEditItems";
import { cancelOrder } from "../../instantAnswers/orders-cancelOrder";
import { cannotFindAnOrder } from "../../instantAnswers/orders-cannotFindAnOrder";
import { damageMissing } from "../../instantAnswers/orders-damagedMissing";
import { editOrderInformation } from "../../instantAnswers/orders-editOrderInformation";
import { internationalOrderSettings } from "../../instantAnswers/orders-internationalOrderSettings";
import { RequestCommissionChanges } from "../../instantAnswers/orders-requestCommissionChanges";
import { orderUnknownStateVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";
export var useOrderUnknownBrandNodes = function useOrderUnknownBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    AddOrEditItemsUnknownState: {
      id: "AddOrEditItemsUnknownState",
      label: strictLocalize({
        id: "XOqOmK",
        defaultMessage: [{
          "type": 0,
          "value": "Ajouter ou modifier des articles dans la commande"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnknownStateVisibilityFn,
      instantAnswer: addOrEditItems(strictLocalize),
      articles: [articles.FulfillingOrders.EDIT_RETAILER_ORDER]
    },
    EditOrderInformationUnknownState: {
      id: "EditOrderInformationUnknownState",
      label: strictLocalize({
        id: "Au/+F5",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier les informations de la commande"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnknownStateVisibilityFn,
      instantAnswer: editOrderInformation(strictLocalize),
      articles: [articles.FulfillingOrders.EDIT_RETAILER_ORDER]
    },
    InternationalOrderSettingsUnknownState: {
      id: "InternationalOrderSettingsUnknownState",
      label: strictLocalize({
        id: "4jq1KK",
        defaultMessage: [{
          "type": 0,
          "value": "Paramètres de commande internationale"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnknownStateVisibilityFn,
      instantAnswer: internationalOrderSettings(strictLocalize),
      articles: [articles.International.LOCATION_SHOP_LIVE]
    },
    DamageMissingItemReportUnknownState: {
      id: "DamageMissingItemReportUnknownState",
      label: strictLocalize({
        id: "YJBiao",
        defaultMessage: [{
          "type": 0,
          "value": "Rapport sur un article endommagé ou manquant"
        }]
      }),
      level: 2,
      instantAnswer: damageMissing(strictLocalize),
      isNodeVisible: orderUnknownStateVisibilityFn
    },
    RequestCommissionChangesUnknownState: {
      id: "RequestCommissionChangesUnknownState",
      label: strictLocalize({
        id: "/jYVoe",
        defaultMessage: [{
          "type": 0,
          "value": "Demander un ajustement de la commission"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnknownStateVisibilityFn,
      instantAnswer: RequestCommissionChanges(strictLocalize),
      articles: [articles.FaireDirect.ZERO_COMMISSION]
    },
    CancelOrderUnknownState: {
      id: "CancelOrderUnknownState",
      label: strictLocalize({
        id: "CJTXVi",
        defaultMessage: [{
          "type": 0,
          "value": "Annuler la commande"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnknownStateVisibilityFn,
      instantAnswer: cancelOrder(strictLocalize),
      articles: [articles.FulfillingOrders.FULFILLING_ORDER]
    },
    CannotFindAnOrderUnknownState: {
      id: "CannotFindAnOrderUnknownState",
      label: strictLocalize({
        id: "lHScAS",
        defaultMessage: [{
          "type": 0,
          "value": "Commande introuvable"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnknownStateVisibilityFn,
      instantAnswer: cannotFindAnOrder(strictLocalize),
      articles: [articles.Account.ORDER_ISSUE, articles.Account.CANNOT_FIND_ORDER_NUMBER]
    }
  };
};